module.exports = __webpack_public_path__ + "static/media/KUN-BUSD.7f801425.svg";